/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
				$( function() {
					$( '.ginput_container:not(.ginput_container_fileupload) > input[type!="hidden"], .ginput_container > select' ).each( function() {
						if( $( this ).val() !== "" ) {
							$( this ).closest( ".gfield:not(.gfield_multi_time)" ).addClass( "has-focus-or-value" );
						}
					} );
				} );

				$( ".gform_wrapper" ).on( 
					"focus", '.ginput_container:not(.ginput_container_fileupload) > input[type!="hidden"], .ginput_container > select', function() {
						$( this ).closest( ".gfield:not(.gfield_multi_time)" ).addClass( "has-focus-or-value" );
					}
				).on( 
					"blur", '.ginput_container:not(.ginput_container_fileupload) > input[type!="hidden"], .ginput_container > select', function() {
						if( $( this ).val() === "" ) {
							$( this ).closest( ".gfield:not(.gfield_multi_time)" ).removeClass( "has-focus-or-value" );
						}
					}
				);



				$( ".image-slideshow .uk-slideshow-items > li" ).on( "itemhide", function( evt ) {
					var slideshowObj	  = null;
					var parentSlideshow = $( this ).closest( ".image-slideshow" );

					if( evt.detail.length > 0 ) {
						slideshowObj = evt.detail[0];
					}					

					parentSlideshow.find( ".slideshow-current-slide-status .js-text-content" )
						.text( ( slideshowObj.getIndex() + 1 ) + "/" + slideshowObj.length );
				} );

				$( ".captioned-slideshow-wrap" ).each( function() {
					if( $( ".slideshow-caption-holder", this ).has( ".slideshow-caption-slide" ).length === 0 ) {
						$( ".slideshow-caption-holder", this ).append( '<div class="slideshow-caption-slide">' );
					}

					if( $( ".image-slideshow .uk-slideshow-items .uk-active", this ).has(
						".slide-copy-holder" ).length > 0 && $( ".slideshow-caption-holder .slideshow-caption-slide:first-child", this ).html() === ""
					) {
						$( ".slideshow-caption-holder .slideshow-caption-slide:first-child", this ).html(
							$( ".image-slideshow .uk-slideshow-items .uk-active .slide-copy-holder", this ).html()
						);
					}

					var slideshowWrap = this;

					$( ".image-slideshow .uk-slideshow-items > li", this ).on( 
						"beforeitemhide", function( evt ) {
							var slideshowObj 	 = null;

							if( evt.detail.length > 0 ) {
								slideshowObj = evt.detail[0];
							}

							var slideToBeShown = $( ".image-slideshow .uk-slideshow-items > li", slideshowWrap )
							.eq(slideshowObj.getIndex());

							if( slideToBeShown.find( ".slide-copy-holder" ).length > 0 ) {
								var newSlideDiv = $( "<div>" )
									.addClass( "slideshow-caption-slide next" )
									.html( slideToBeShown.find( ".slide-copy-holder" ).html() );

								$( ".slideshow-caption-holder", slideshowWrap )
									.append( newSlideDiv )
									.height( newSlideDiv.prop( "scrollHeight" ) );
							}
						}
					).on(
						"itemhide", function( evt ) {
							var slideshowObj = null;

							if( evt.detail.length > 0 ) {
								slideshowObj = evt.detail[0];
							}

							// Make the old slide the previous slide
							$( ".slideshow-caption-holder .slideshow-caption-slide:not('.next')", slideshowWrap )
								.addClass( "prev" );

							// Make the new slide the current slide
							$( ".slideshow-caption-holder .slideshow-caption-slide.next", slideshowWrap )
								.removeClass( "next" );
						}
					).on(
						"itemhidden", function( evt ) {
							$( ".slideshow-caption-holder .slideshow-caption-slide.prev", slideshowWrap ).remove();
						}
					);
				} );
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
				// Trigger popup if enabled
				if( $( '.promo-pop-up-modal-container' ).length > 0 ) {
					$( "#promoPopUpTrigger" ).delay( 2000 ).click();
				}
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
